import Cookies from 'js-cookie';
import { checkProductLength, getSkuType } from '../helper';
import { v4 as uuidv4 } from 'uuid';
import { fireFbConversionApiEvent } from '../../Libs/fbpixel';
import { fireEvent } from '../fireEvent';

export const firePurchaseEvent = () => {
  let userDetails = '';
  let addressDetail = '';
  if (Cookies.get('react_user_properties')) {
    userDetails = JSON.parse(Cookies.get('react_user_properties'));
  }
  if (Cookies.get('is_default')) {
    addressDetail = JSON.parse(Cookies.get('is_default'));
  }
  const fireOrderEvents = async (completeOrderData, page, paymentMode) => {
    localStorage.setItem('tempData', JSON.stringify(completeOrderData));
    const orderData = completeOrderData?.data;
    const priceDetails = completeOrderData?.price_detail;
    const allOrderIds = completeOrderData?.orderIds;
    const eventId = getRandomEventId();
    let orderIds = [];
    let productId = [];
    let quantity = [];
    let prices = [];
    let skuNickname = [];
    let totalQuantity = getTotalQuantity(completeOrderData);
    let orderPriceTotal = 0;
    // const user = Cookies.get("is_default")
    //     ? JSON.parse(Cookies.get("is_default"))
    //     : null;
    // const phoneNo = "91" + user?.mobile;
    // const user_data = {
    //     phone: phoneNo ? phoneNo : "",
    //     email: user?.email ? user?.email?.toLowerCase() : "",
    //     zipcode: user?.zipcode ? user?.zipcode : "",
    // };

    orderData?.forEach((product, index) => {
      const { orderPrice } = updateDataPurchase(
        orderIds,
        productId,
        quantity,
        product,
        allOrderIds?.[index],
        page,
        skuNickname,
        prices,
      );

      orderPriceTotal += orderPrice;
      let { strikePrice, productPrice, gullackDiscount, deliveryCharge } =
        paramsRequired(page, product);
      let pricing_param = createParamStr([
        strikePrice,
        productPrice,
        gullackDiscount,
        'NA',
      ]);
      let conversion_param = createParamStr([
        productPrice,
        deliveryCharge,
        productPrice + deliveryCharge,
      ]);
      let coupon_id = product?.coupon_id;
      let product_id = product?.product_id;
      let sku_name = product?.product_name;
      let {
        order_id,
        parent_order_id,
        term_id,
        offer_id,
        mobile,
        order_edd,
        type,
      } = eventRequriedKeys(
        product,
        completeOrderData,
        allOrderIds?.[index],
        page,
      );
      const fetchedNickname =
        page == 'orderSuccess' ? product?.nickname : product?.product_nickname;
      const nickname = fetchedNickname
        ? checkProductLength(fetchedNickname)
        : checkProductLength(product?.product_name);
      if (coupon_id) {
        fireEvent({
          category: 'offer_redeemed',
          order_id: order_id,
          support_variable: parent_order_id,
          term_id: term_id,
          offer_id: offer_id,
          coupon_id: coupon_id,
          mobile_number: mobile,
          id: product_id,
          pricing_param: pricing_param,
          conversion_param: conversion_param,
        });
      }
      fireEvent({
        category: 'order_completed',
        order_id: order_id,
        support_variable: parent_order_id,
        term_id: term_id,
        offer_id: offer_id,
        coupon_id: coupon_id,
        mobile_number: mobile,
        sku_nickname: nickname,
        sku_id: product_id,
        sku_name: sku_name,
        order_edd: order_edd,
        sku_type: getSkuType(type),
        pricing_param: pricing_param,
        conversion_param: conversion_param,
        quantity: totalQuantity,
        address_detail: getUserDetail(),
        event_id: eventId,
        payment_mode: paymentMode,
        //user_data: JSON.stringify(user_data),
      });
    });
    let contents = [];
    // contents.push({ orderIds: orderIds });
    for (let i = 0; i < orderData?.length; i++) {
      const nickname = checkProductLength(skuNickname[i]);

      let content = {
        item_id: productId[i],
        quantity: quantity[i],
        item_name: nickname,
        price: orderData[i]?.offer_id ? prices[i] / quantity[i] : prices[i],
      };

      contents.push(content);
    }
    const { selling_price, deliver_price, order_value } = getPurchaseEventKeys(
      priceDetails,
      page,
    );

    localStorage.setItem('eventId', eventId);
    fireEvent({
      category: 'purchase',
      value: orderPriceTotal.toFixed(1),
      transaction_id: completeOrderData?.parent_order_id,
      currency: 'INR',
      //item_id: productId,
      content_type: 'product',
      items: contents,
      selling_price: selling_price,
      deliver_price: deliver_price,
      order_value: order_value,
      event_id: eventId,
    });
    await fireFbConversionApiEvent(
      'Purchase',
      {
        content_ids: productId,
        content_type: 'product',
        value: selling_price,
        currency: 'INR',
      },
      eventId,
    );
  };
  const getRandomEventId = () => {
    const randomNumber = uuidv4();
    const EventId = `event${randomNumber}`;
    return EventId;
  };
  const getPurchaseEventKeys = (priceDetails, page) => {
    let selling_price, deliver_price, order_value;
    if (page == 'orderSuccess') {
      // selling_price = !isAppUser()
      //     ? priceDetails?.item_price
      //     : priceDetails?.total_mrp;
      selling_price = priceDetails?.item_price;

      deliver_price = priceDetails?.delivery_charge;
      order_value = priceDetails?.final_price;
    } else {
      selling_price = priceDetails?.orderItemTotal;
      deliver_price = priceDetails?.orderDeliveryTotal;
      order_value = priceDetails?.orderFinalPriceTotal;
    }
    return { selling_price, deliver_price, order_value };
  };

  const getProductCost = (product) => {
    let productPrice = product?.coupon_id
      ? product?.price
      : product?.quantity * product?.price;
    return productPrice;
  };
  const paramsRequired = (page, product) => {
    let strikePrice = product?.quantity * product?.strikeprice;
    let productPrice;
    let gullackDiscount;
    let deliveryCharge = product?.delivery_charge;
    if (page == 'orderSuccess') {
      productPrice = product?.cart_total;
      gullackDiscount =
        product?.gullack_discount || product?.gullack_discount == 0
          ? product?.gullack_discount
          : 'NA';
    } else {
      productPrice = getProductCost(product);
      gullackDiscount =
        product?.gullack_points_used || product?.gullack_points_used == 0
          ? product?.gullack_discount
          : 'NA';
    }
    return { strikePrice, productPrice, gullackDiscount, deliveryCharge };
  };
  const getUserDetail = () => {
    let obj = `{
          'email': ${userDetails.email ? userDetails.email : ''}
          'zipcode' : ${addressDetail.zipcode ? addressDetail.zipcode : ''},
          'city': ${addressDetail.city ? addressDetail.city : ''},
          'state': ${addressDetail.state ? addressDetail.state : ''},
          'name': ${addressDetail.name ? addressDetail.name : ''},
          'address_line_1': ${
            addressDetail.address_line_1 ? addressDetail.address_line_1 : ''
          },
          'address_line_2': ${
            addressDetail.address_line_2 ? addressDetail.address_line_2 : ''
          },
      }`;
    let values = obj.replace(/\n/gi, '');
    let string = values.replace(/\ /gi, '');
    return string;
  };
  const getTotalQuantity = (data) => {
    let quantity = 0;
    data?.data.forEach((element) => {
      quantity += element.quantity;
    });
    return quantity;
  };

  const updateDataPurchase = (
    orderIds,
    productId,
    quantity,
    product,
    orderId,
    page,
    skuNickname,
    prices,
  ) => {
    let orderPrice = 0;
    productId.push(product?.product_id);
    quantity.push(product?.quantity);
    skuNickname.push(product?.product_nickname);
    prices.push(product?.price);
    if (page == 'orderSuccess') {
      orderIds.push(product?.id);
      orderPrice += product?.cart_total;
    } else {
      orderIds.push(orderId);
      orderPrice += getProductCost(product);
    }
    return { orderPrice };
  };

  const createParamStr = (arr) => {
    return arr.join(', ');
  };

  const eventRequriedKeys = (product, allData, orderId, page) => {
    let order_id, parent_order_id, term_id, offer_id, mobile, order_edd, type;
    if (page == 'orderSuccess') {
      order_id = product?.id;
      parent_order_id = product?.parent_order_id;
      term_id = product?.term_id || null;
      offer_id = product?.offer_id || null;
      mobile = product?.mobile;
      order_edd = product?.estimatedDeliveryTime?.replace('Arriving by ', '');
      type = product.type;
    } else {
      order_id = orderId;
      parent_order_id = allData?.parent_order_id;
      term_id = product?.offer_id || null;
      offer_id = allData?.offerId || null;
      mobile = allData?.mobile;
      order_edd = allData?.deliveryTime?.replace('Arriving by ', '');
      type = product.sku_type;
    }
    return {
      order_id,
      parent_order_id,
      term_id,
      offer_id,
      mobile,
      order_edd,
      type,
    };
  };
  return { fireOrderEvents };
};
